<template>
	<div class="listing-images">
    <ImageGallery v-if="showGallery" @closeGallery="closeGallery" :index="galleryIndex" :images="images"></ImageGallery>
    <!--<a @click.prevent="openGallery(0)" href="#" class="listing-images__view">{{$store.getters.language.view_photos}}</a>-->
    <div class="listing-images__grid" :class="[`layout--${ images.edges.length > 5 ? 5 : images.edges.length }`]">
      <div class="listing-images__item"
        v-if="thumbIndex <= 4"
        v-for="(thumb, thumbIndex) in images.edges"
        :key="thumbIndex"
        @click.prevent="openGallery(thumbIndex)"
      >
        <img :src="thumb.node.imageUrl">
      </div>
    </div>
    <div class="listing-images__buttons">
      <ButtonPrimary v-if="organisation === 'Nhood'"
          :title="$store.getters.language.view_floorplan"
          @buttonClick="openModal(null , 'map')"
      />
      <ButtonPrimary :title="$store.getters.language.view_photos" @buttonClick="openGallery(0)"></ButtonPrimary>
      <ButtonPrimary :title="$store.getters.language.view_floorplan" @buttonClick="openModal(`<img src='${listing.floorplanImageUrl}'>`, 'img')" v-if="listing.floorplanImageUrl && organisation !== 'Nhood'"></ButtonPrimary>
    </div>

    <SpacesModal v-if="modal.visible && modal.type === 'img'" @close="modal.visible = false, modal.description = null" :description="modal.description" :large="true"></SpacesModal>

    <SpacesModal v-if="modal.visible && modal.type === 'map'" @close="modal.visible = false, modal.description = null" :description="modal.description" :large="true">
      <mapplic-map id="space-map" :data-json="`https://mapplic.com/getMapData?id=${mapId}`"></mapplic-map>
    </SpacesModal>
	 </div>
</template>

<script>
// @ is an alias to /src
import Flickity from 'vue-flickity';
import ImageGallery from "../../components/search/ImageGallery"
import SpacesModal from "../../components/search/SpacesModal"
import ButtonPrimary from "../../components/global/ButtonPrimary"
import axios from "axios";

export default {
  name: 'ImageViewer',
  data: () => ({
    organisation: null, // Default value to prevent breaking
    showGallery: false,
    galleryIndex: 0,
    mapId: 'dWwYd277zQZwgiUUuvur',
    modal: {
      visible: false,
      type: null,
      description: null
    }
  }),
  components: {
    Flickity,
    ImageGallery,
    SpacesModal,
    ButtonPrimary
  },
  watch: {
  },
  created () {

  },
  mounted () {
    console.log("Space ID:", this.space_id);  // Use camelCase here
    console.log("Space ID:", this.iframe_embed);  // Use camelCase here
    this.mapId = this.iframe_embed
    this.organisation = organisation
  },
  props: {
    images: {
      default: null,
      type: Object
    },
    listing: {
      default: null,
      type: Object
    },
    space_id: {
      type: String
    },
    iframe_embed: {
      type: String
    }
  },
  methods: {
    openModal (description, type) {
      this.modal.visible = true
      this.modal.type = type
      this.modal.description = description

      if (this.modal.type === 'map') {
        this.openLocation()
      }
    },
    openLocation () {
      this.$nextTick(() => {
        const map = document.getElementById('space-map')
        map.addEventListener('mapReady', e => {

          const store = map.store
          setTimeout (() => {
            store.getState().openLocation(this.space_id)
          }, 2000)
        })
      })
    },
    openGallery (index) {
        this.galleryIndex = index
      this.showGallery = true
    },
    closeGallery () {
      this.galleryIndex = 0
      this.showGallery = false
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../scss/global/includes";


.listing-images {
  position: relative;
  @include breakpoint(tablet-landscape) {
    display: none;
  }
}

.listing-images__grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(6, 8fr);
  grid-gap: 8px;
  aspect-ratio: 2.5/1;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.listing-images__view {
  position: absolute;
  top: 15px;
  left: 15px;
  z-index: 1001;
  font-size: 12px;
  letter-spacing: -0.2px;
  line-height: 1.2;
  text-transform: uppercase;
  color: $strong-light;
  background-color: #ffffff;
  overflow: visible;
  border-radius: 2px;
  padding: 10px 24px;
  font-family: $font-bold;
  @include ease-fast;
  &:hover {
    color: #FFFFFF;
    background-color: $green;
  }
  @include breakpoint(tablet-landscape) {
    display: none;
  }
}

.listing-images__buttons {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 4px;
}

.listing-images__item { 
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  background: $divider-dark;
  /*
  &:nth-child(1) {
    grid-row: 1 / 8;
    grid-column: 1 / 7;
  }
  &:nth-child(2), &:nth-child(4) {
    grid-column: 7 / 10;
  }
  &:nth-child(3), &:nth-child(5) {
    grid-column: 10 / 13;
  }

  &:nth-child(2), &:nth-child(3) {
    grid-row: 1 / 4;
  }

  &:nth-child(4), &:nth-child(5) {
    grid-row: 4 / 8;
  }
  */

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

}

.layout--1 {
  .listing-images__item {
    grid-row: 1 / 8;
    grid-column: 1 / 13;
  }
}

.layout--2 {
  .listing-images__item {
    &:nth-child(1) {
      grid-row: 1 / 8;
      grid-column: 1 / 7;
    }
    &:nth-child(2) {
      grid-row: 1 / 8;
      grid-column: 7 / 13;
    }
  }
}

.layout--3 {
  .listing-images__item {
    &:nth-child(1) {
      grid-row: 1 / 8;
      grid-column: 1 / 9;
    }
    &:nth-child(2) {
      grid-row: 1 / 4;
      grid-column: 9 / 13;
    }
    &:nth-child(3) {
      grid-row: 4 / 8;
      grid-column: 9 / 13;
    }
  }
}

.layout--4 {
  .listing-images__item {
    &:nth-child(1) {
      grid-row: 1 / 8;
      grid-column: 1 / 7;
    }
    &:nth-child(2) {
      grid-row: 1 / 4;
      grid-column: 7 / 13;
    }
    &:nth-child(3) {
      grid-row: 4 / 8;
      grid-column: 7 / 10;
    }
    &:nth-child(4) {
      grid-row: 4 / 8;
      grid-column: 10 / 13;
    }
  }
}

.layout--5 {
  .listing-images__item {
    &:nth-child(1) {
      grid-row: 1 / 8;
      grid-column: 1 / 7;
    }
    &:nth-child(2) {
      grid-row: 1 / 4;
      grid-column: 7 / 10;
    }
    &:nth-child(3) {
      grid-row: 1 / 4;
      grid-column: 10 / 13;
    }
    &:nth-child(4) {
      grid-row: 4 / 8;
      grid-column: 7 / 10;
    }
    &:nth-child(5) {
      grid-row: 4 / 8;
      grid-column: 10 / 13;
    }
  }
}


.placeholder {
    background: $divider-dark;
    cursor: auto;
}

</style>
